<div class="candidate-progress">
  <div class="container">
    <ng-container *ngIf="progressState$ | async as progressState; else loading">
      <ng-container *ngIf="learningObjectives$ | async as learningObjectives;">
        <ng-container *ngIf="progressState.progress?.candidateName">
          <ng-container *ngIf="progressState.candidate">
            <div class="row p-3">
              <div class="col d-flex align-items-center">
                <app-inline-edit label="LABEL"
                                #appInline
                                class="h4 my-1 flex-grow-1 d-block"
                                id="ID"
                                [value]="progressState.progress.candidateName"
                                type="text"
                                required="true"
                                requiredMessage="REQUIREDMESSAGE"
                                placeholder="PLACEHOLDER"
                                (Save)="onSave(progressState.progress.candidateId, appInline.value)">
                </app-inline-edit> <button (click)="close(progressState.progress.candidateId);"
                        class="btn btn-primary mdi mdi-close ml-3">Sluiten</button>
              </div>
            </div>
            <div class="row px-3 pb-3">
              <div class="col">
                <hr class="w-100">
                <h5 class="mb-4">Leerlingprofiel</h5>
                <div class="row mb-4">
                  <div class="col-5 d-flex flex-column justify-content-start">
                    <strong>Naam: </strong>
                    <strong>Geboortedatum: </strong>
                    <strong>Groep: </strong>
                    <strong>Profiel: </strong>
                  </div>
                  <div class="col-7 d-flex flex-column justify-content-end text-right">
                    <span>{{progressState.progress.candidateName}}</span>

                    <span *ngIf="progressState.candidate.birthDate">{{getBirthDate(progressState.candidate.birthDate)}}</span>
                    <span *ngIf="!progressState.candidate.birthDate">-</span>

                    <span *ngIf="progressState.candidate.yearGroup">{{progressState.candidate.yearGroup}}</span>
                    <span *ngIf="!progressState.candidate.yearGroup">-</span>

                    <ng-container *ngIf="(citoModule$ | async) === citomodules.Rekenen">
                      <span *ngIf="progressState.candidate.learningRoutesList[0]">{{progressState.candidate.learningRoutesList[0]}}</span>
                      <span *ngIf="!progressState.candidate.learningRoutesList[0]">Geen profiel</span>
                    </ng-container>

                    <ng-container *ngIf="(citoModule$ | async) === citomodules.Spelling">
                      <span *ngIf="progressState.candidate.learningRoutesSpellingList[0]">{{progressState.candidate.learningRoutesSpellingList[0]}}</span>
                      <span *ngIf="!progressState.candidate.learningRoutesSpellingList[0]">Geen profiel</span>
                    </ng-container>

                  </div>
                </div>
                <hr>
                <h5 class="my-4">Bewerk leerlingprofiel</h5>
                <ng-container *ngIf="(citoModule$ | async) === citomodules.Rekenen">
                  <div class="row mb-4">
                    <div class="col">
                      <h6>Op weg naar referentieniveau voor reguliere leerlingen:</h6>
                      <div class="form-check d-flex align-items-center pr-0">
                        <input class="form-check-input"
                              type="radio"
                              name="exampleRadios"
                              id="radio1"
                              [value]="1"
                              [(ngModel)]="learningRouteRadio">
                        <select class="form-control ml-auto w-50"
                                id="exampleFormControlSelect1"
                                [(ngModel)]="learningRoute"
                                [disabled]="learningRouteRadio === 2"
                                >
                          <option [value]=""></option>
                          <option [value]="'1F'">1F</option>
                          <option [value]="'1S'">1S</option>
                          <option [value]="">Geen profiel</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-5">
                    <div class="col">
                      <h6>Leerroute voor leerlingen met een passend perspectief:</h6>
                      <div class="form-check d-flex align-items-center pr-0">
                        <input class="form-check-input"
                              type="radio"
                              name="radio1"
                              id="exampleRadios1"
                              [value]="2"
                              [(ngModel)]="learningRouteRadio"
                                >
                        <select class="form-control ml-auto w-50"
                                id="exampleFormControlSelect1"
                                [(ngModel)]="learningRoute"
                                [disabled]="learningRouteRadio === 1"
                                >
                          <option [value]=""></option>
                          <option [value]="'L1'">L1</option>
                          <option [value]="'L2'">L2</option>
                          <option [value]="'L3'">L3</option>
                          <option [value]="">Geen profiel</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="(citoModule$ | async) === citomodules.Spelling">
                  <div class="row mb-4">
                    <div class="col">
                      <h6>Op weg naar referentieniveau voor reguliere leerlingen:</h6>
                      <div class="form-check d-flex align-items-center pr-0">
                        <input class="form-check-input"
                              type="radio"
                              name="exampleRadios"
                              id="radio1"
                              [value]="1"
                              [(ngModel)]="learningRouteRadio">
                        <select class="form-control ml-auto w-50"
                                id="exampleFormControlSelect1"
                                [(ngModel)]="learningRoute"
                                [disabled]="learningRouteRadio === 2"
                                >
                          <option [selected]="learningRoute === '1F'" [value]="'1F'">1F</option>
                          <option [selected]="learningRoute === '2F'" [value]="'2F'">2F</option>
                          <option [selected]="learningRoute === '3F'" [value]="'3F'">3F</option>
                          <option [selected]="learningRoute === ''" [value]="">Geen profiel</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <div class="row mb-4">
                  <div class="col d-flex">
                    <!-- <button (click)="removeProfile(progressState.progress.candidateId)"
                            class="btn btn-outline-dark ml-auto">Profiel wissen
                    </button> -->
                    <button (click)="saveProfile(progressState.progress.candidateId)"
                            class="btn btn-primary ml-auto">Profiel opslaan
                    </button>
                  </div>
                </div>
                <hr>
              </div>
            </div>
            <div class="row px-3">
              <div class="col">
                <h5 class="mb-4">Afgesloten leerdoelen {{candidateName}}</h5>

                <ng-container *ngIf="progressState.progress.lastFiveLearningObjectivesDone?.length > 0">
                  <div class="border-bottom py-2" *ngFor="let learningObjective of progressState.progress?.lastFiveLearningObjectivesDone; let i = index;">
                    <div class="list-item">
                      <div class="d-flex align-items-center">
                        <img appPlannerIndicator
                            class="flex-grow-0"
                            state="{{learningObjective.assignmentStatus}}" />
                        <div class="flex-grow-1">
                          <app-learning-objective-view [learningObjective]="getLearningObjective(learningObjective.learningObjectiveId, learningObjectives)">
                          </app-learning-objective-view>
                        </div>

                      </div>
                      <div class="small text-right text-secondary">{{ learningObjective.formattedDate }}</div>
                    </div>
                  </div>
                </ng-container>

                <div *ngIf="progressState.progress?.lastFiveLearningObjectivesDone == null || progressState.progress?.lastFiveLearningObjectivesDone?.length === 0">
                  <p>{{ 'NO_SESSION_DATA' | translate }}</p>
                </div>
              </div>
            </div>
            <!-- <div class="progress-emoji position-absolute mx-5 my-3">
                <img style="width:100%; height:100%"
                        [src]="'assets/Emoji/' + progressState.progress?.emoji?.split('  ').join(' ').split(' ').join('_') + '.png'"
                />
            </div> -->
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>



<ng-template #loading>Loading User Data...</ng-template>
